import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=ca6a6352&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=ca6a6352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6a6352",
  null
  
)

export default component.exports